<script setup>
import { EllipsisVertical } from 'lucide-vue-next'
</script>

<template>
  <EllipsisVertical />
</template>
